import "core-js"

import "../css/index.css"

import { setupLegalPolicy } from "../site/templates/views/el/legal-info/utils"
import { setupScrollToTop } from "../site/templates/views/el/scroll-to-top/utils"

import { setupGallery } from "../site/templates/views/el/obrazy/utils"
import { setupCarForm } from "../site/templates/views/el/car/utils"
import { setupMenu } from "../site/templates/views/el/header/utils"

document.addEventListener("DOMContentLoaded", function () {
  setupLegalPolicy((window as any).LEGAL_POLICY_URL || "#")

  setupMenu()
  setupScrollToTop()

  setupGallery()

  setupCarForm("reservation-form")
})
